import * as React from "react";
const StopPropagation = (props) => {
  const { children, element: Element = "div" } = props;
  const stopPropagation = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };
  return /* @__PURE__ */ React.createElement(Element, { onClick: stopPropagation }, children);
};
export {
  StopPropagation
};
